import React from "react";

// Third Party
import { Link, type LinkProps } from "react-router-dom";

interface AnchorProps extends LinkProps {}

const Anchors: React.FC<AnchorProps> = ({ to, className, ...rest }) => {
  return <Link className={`p-0 rounded ${className}`} to={to} {...rest} />;
};

export default Anchors;
